import { VisitNodePassage } from "../../../types";
export const benchmark = (measureName, measureType, shouldTakeLatestDataDate) => (args) => {
    if (args.context.visitNodePassage !== VisitNodePassage.NodeLast && args.context.visitNodePassage !== VisitNodePassage.Always) {
        return;
    }
    const element = args.visitable;
    const measures = element?.data ? element?.data[0].measures : element.measures;
    const benchmarkName = measures?.[measureName];
    const hasCustomBenchmark = measures?.[measureType];
    if (args.context.staticData.root?.[0]) {
        if (!args.context.staticData.root[0].additionalData) {
            args.context.staticData.root[0].additionalData = {};
        }
        args.context.staticData.root[0].additionalData.benchmark = benchmarkName;
        args.context.staticData.root[0].additionalData.hasCustomBenchmark = hasCustomBenchmark;
        args.context.staticData.root[0].additionalData.shouldTakeLatestDataDate = shouldTakeLatestDataDate;
    }
};
